/* eslint-disable import/no-cycle */
// Utils
import { isObject } from 'ezyvet-fe-helpers';
import { findObjectWithIdInObject } from './findObjectWithIdInObject';
import { findObjectWithIdInArray } from './findObjectWithIdInArray';
/**
 * Find the object with the given object id in the given value
 *
 * @param {any} value
 * @param {string} objectId
 *
 * @return {Identifiable<object> | undefined}
 */
export var findObjectFromValue = function (value, objectId) {
    var result;
    if (isObject(value)) {
        result = findObjectWithIdInObject(value, objectId);
    }
    else if (Array.isArray(value)) {
        result = findObjectWithIdInArray(value, objectId);
    }
    return result;
};
//# sourceMappingURL=findObjectInValue.js.map